(function () {
  'use strict';

  var drawer = document.getElementById('ei-burger-drawer');
  var overlay = document.getElementById('ei-burger-overlay');
  var closeBtn = document.getElementById('ei-burger-close');
  var searchTrigger = document.getElementById('ei-burger-search-trigger');

  if (!drawer || !overlay) return;

  var v5overlay = document.getElementById('ei-menu-overlay');
  if (v5overlay) v5overlay.style.display = 'none';

  var openedAt = 0;

  /* Paramètres EI lus par la balise GTM « GA4 - EI Nav refonte Events ».
     La couche de données CONSERVE les valeurs d'un push à l'autre : sans remise à
     zéro, un ei_rayon posé par un rayon_toggle resterait collé aux events suivants
     (constaté le 02-08-2026 sur un ei_search_result_click). On les repasse donc
     tous à undefined avant d'appliquer ceux de l'event courant. */
  var EI_PARAMS = ['ei_source', 'ei_action', 'ei_product', 'ei_query', 'ei_result_type', 'ei_rayon', 'ei_position', 'ei_sav_item'];

  function track(event, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    for (var i = 0; i < EI_PARAMS.length; i++) payload[EI_PARAMS[i]] = undefined;
    for (var k in params) payload[k] = params[k];
    window.dataLayer.push(payload);
  }

  function openDrawer() {
    openedAt = Date.now();
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ei-burger-open');
    track('ei_burger_open', {
      ei_source: 'burger_menu',
      ei_device: window.innerWidth < 768 ? 'mobile' : 'tablet'
    });
    var firstFocusable = drawer.querySelector('button, a');
    if (firstFocusable) setTimeout(function () { firstFocusable.focus(); }, 50);
  }

  function closeDrawer() {
    var duration = openedAt ? Date.now() - openedAt : 0;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ei-burger-open');
    track('ei_burger_close', { ei_source: 'burger_menu', ei_duration_ms: duration });
  }

  var triggers = document.querySelectorAll(
    '#ei-menu-open, [data-ei-burger-open], .ei-mobile-header__hamburger'
  );
  triggers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  var touchStartX = 0;
  var touchStartY = 0;
  drawer.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
  }, { passive: true });
  drawer.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].screenX - touchStartX;
    var dy = e.changedTouches[0].screenY - touchStartY;
    if (dx < -60 && Math.abs(dy) < 80) closeDrawer();
  }, { passive: true });

  drawer.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ei-action]');
    if (!el) return;
    var action = el.getAttribute('data-ei-action');
    var params = { ei_source: 'burger_menu', ei_action: action };
    if (el.getAttribute('data-ei-rayon')) params.ei_rayon = el.getAttribute('data-ei-rayon');
    if (el.getAttribute('data-ei-item')) params.ei_sav_item = el.getAttribute('data-ei-item');
    track('ei_' + action, params);
  });

  if (searchTrigger) {
    searchTrigger.addEventListener('click', function () {
      closeDrawer();
      if (window.EISearchOverlay) { window.EISearchOverlay.open({ source: 'burger_menu' }); }
    else { window.location.href = '/search'; }
    });
  }

  var quoteEl = drawer.querySelector('.js-ei-avis-quote');
  var authorEl = drawer.querySelector('.js-ei-avis-author');
  if (quoteEl && quoteEl.dataset.verbatims) {
    try {
      var verbatims = JSON.parse(quoteEl.dataset.verbatims);
      if (verbatims && verbatims.length) {
        var v = verbatims[Math.floor(Math.random() * verbatims.length)];
        quoteEl.textContent = '\u00AB\u00A0' + v.text + '\u00A0\u00BB';
        if (authorEl) authorEl.textContent = '\u2014 ' + v.author + ', Trustpilot';
      }
    } catch (err) {}
  }

  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var focusable = Array.from(drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Accordéon rayons — seul le chevron déplie ; le libellé reste un vrai lien */
  drawer.addEventListener('click', function (e) {
    var tog = e.target.closest ? e.target.closest('.ei-burger-acc-tog') : null;
    if (!tog) return;
    e.preventDefault();
    var acc = tog.closest('.ei-burger-acc');
    if (!acc) return;
    var open = acc.getAttribute('aria-expanded') === 'true';
    acc.setAttribute('aria-expanded', String(!open));
    tog.setAttribute('aria-expanded', String(!open));
    track('ei_rayon_toggle', { ei_source: 'burger_menu', ei_rayon: acc.querySelector('.ei-burger-acc-name') ? acc.querySelector('.ei-burger-acc-name').textContent : '' });
  });

  window.EIBurgerMenu = { open: openDrawer, close: closeDrawer };
})();